module.exports = __webpack_public_path__ + "static/media/bees-345628_1920.5a05aa2b.jpg";